import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Card from '../common/Card';
import Content from '../common/Content';
import ListColumns from '../content/list/ListColumns';
import GridCharts from '../content/grid/GridCharts';
import ListV2 from '../content/list/ListV2';
import Spinner from '../common/Spinner';
import DelayButton from '../common/DelayButton';
import ButtonPlaylistCart from '../cart/ButtonPlaylistCart';

import useGetOne from '../../../hooks/useGetOne';
import usePageScroll from '../../../hooks/usePageScroll';
import useCartPlaylist from '../cart/hooks/useCartPlaylist';
import usePlaylist from '../../../hooks/usePlaylist';
import JoinLinkage from '../common/JoinLinkage';
import Linkage from '../common/Linkage';

function ConnectedRelease({ id, trackID = null, api, storePlaylists, width, height, storePopup, enableActionsButton }) { 
  const { item } = useGetOne(api, `/catalog/releases/${id}`, null);
  let { onScroll } = usePageScroll();

  trackID = (trackID) ? trackID : (item ? item.tracks[0].replace('https://api.beatport.com/v4/catalog/tracks/', '').replace('/', '') : '' ); 

  const images = (item)
  ? ( (item.release_images && item.release_images.length > 0)  ? item.release_images : [(item.image && item.image.uri !== Config.DEFAULT_IMG) ? item.image.uri : ( (item.person && item.person.owner_image) ? item.person.owner_image : Config.DEFAULT_IMG)] )
  : null;

  const directCopy = () => {
    if (enableActionsButton) {
      const nbTracks = (item.track_count) ? item.track_count : 100;
      api.getFromApi(`/catalog/releases/${id}/tracks/?per_page=${nbTracks}`, false).then( response => {
        const playlistName = item.name;
        const extra = {
          covers: null,
          fromDJ: null,
          fromDJID: null
        }
        const data = [...response.data.results.map(Config.formattedFromBP)];
        const next = response.data.next;
        storePlaylists.new(playlistName, data, extra, next);
      } ).catch( e => console.log(`error`, e) );
    } else {
      storePopup.playlist('.playlist-button-save'); //storeAuth.link();
    }
  }

  const { beginDrag } = usePlaylist(item, `/catalog/releases/${id}`, 'releases');
  const { addPlaylistToCart } = useCartPlaylist(`/catalog/releases/${id}`, 'releases');

  return (!item)
    ? <Spinner />
    : (
        <div className={`release-page global-page`} style={{ height }} onScroll={onScroll}>
          <Content name={item.name} isSticky={true} showTitle={false}
            scrollIntoView={false}
            stickyClassName={`global-sticky-menu wild`}
            contentClassName={`content-release`}
            styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
            subContent={(
              <div className='flexRow'>
                <div className={`flexRow release-content`}>
                  <Card
                    images={images}
                    audio={{
                      id: item.id,
                      name: item.name,
                      tracks: item.track_count,
                      showDNav: false,
                      extra: null
                    }}
                    dragEnabled={true}
                    playEnabled={true}
                    beginDrag={beginDrag}
                    type={`CHART`}
                    style={{width: Config.PLAYLIST_COVER_SIZE }}
                    ooWidth={Config.PLAYLIST_COVER_SIZE}
                    tag={(item.pre_order) ? 'Pre-order' : null /* (!item.is_available_for_streaming ? `Preview` : null )*/}
                  />
                  <div className={`playlist-infos flexRow space-between`} style={{width: width - 120}}>     
                    <div className={'flexColumn f-center'}>
                      <p className={`playlist-title type-title`}>{Config.camelCase(item.name)}</p>
                      <p className={`playlist-p type-small`}>
                        { (item.artists) && item.artists.slice(0,10).map( (a, i) => (
                          <JoinLinkage key={a.id} label={`${a.name}`} separator={(i !== 0) ? `, ` : ``} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
                        )) }
                        <span> • </span>
                        <Linkage label={item.label.name} to={`/labels/${item.label.slug}/${item.label.id}`} linkClassName={`link-enable`} />
                        {` • `}{item.track_count} Tracks         
                      </p>  
                    </div>
                    <div className={'flexColumn f-center'}>
                      <div className='flexRow' style={{gap: 8}}>
                        <DelayButton
                          label={'Save playlist'}
                          classNameEnable={`playlist-button-save ${Config.ACRONYME}`}
                          classNameDisable={`playlist-button-save ${Config.ACRONYME} disable`}
                          onClick={directCopy}
                        />
                        <ButtonPlaylistCart onClick={addPlaylistToCart} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          >

            <ListV2
              id={item.id}
              data={null}
              pathApi={`/catalog/releases/${id}/tracks/?per_page=100`}
              sortable={false}
              width={width}
              height={ Config.LIST_ROW_HEIGHT * item.track_count }
              size={Config.LIST_ROW_HEIGHT}
              style={{ marginTop: 0, height: 'auto' }}
              filtersStyle={{ display: `none`, top: 0, right: 0 }}
              panelStyle={{ margin: `6px 0px 19px 0px` }}
              filters={[]}
              type={`Full#`}
              enableKeys={true}
              enableShortcuts={true}
              orderBy={[]}
              isBoost={true}
              automix={false}
              from={ `/releases/${id}/${trackID}` }
              isLoadMore={false}
            />

            <ListColumns
              title={'Recommendations'}
              pathApi={`/catalog/tracks/${trackID}/beatbot`}
              id={`{A}recommended-tracks`}
              width={width}
              height={(Config.LIST_ROW_HEIGHT * 5)}
              size={Config.LIST_ROW_HEIGHT}
              columnCount={2}
              rowCount={5}
              rowType={`Column`}
              hasPagination={false}
              enableArrows={true}
            /> 

            <GridCharts title={`Appears On`} id={`{B}Appears On`}
              width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
              hasPagination={false} allTo={`/bp/b-sides`} allLabel={`View All`}
              arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
              pathApi={`/catalog/tracks/${trackID}/charts/` }
              className={`grid-chart`}
            />

            {/* <ListColumns
              title={'People Also Bought'}
              pathApi={`/catalog/releases/${id}/uab`}
              id={`{C}people-also-bought`}
              width={width}
              height={(Config.LIST_ROW_HEIGHT * 5)}
              size={Config.LIST_ROW_HEIGHT}
              columnCount={2}
              rowCount={5}
              rowType={`Column`}
              hasPagination={false}
              enableArrows={true}
            />  */}

          </Content>
        </div>
    )
}

ConnectedRelease.propTypes = {
  id: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any,
}

const Release = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height,
    api: state.api,
    enableActionsButton: (state.isConnected),
    storePopup: state.storePopup,
    storePlaylists: state.storePlaylists
  })
)(ConnectedRelease);

export default Release;
